import { Navigate } from "react-router-dom";
import { useRecommendationEngineAuth } from "./RecommendationEngineAuthProvider";


const RecomEnginePrivateRoute = ({children}) => {
    const { isRecomEngineAuthenticated } = useRecommendationEngineAuth();

    if (!isRecomEngineAuthenticated) {
        return <Navigate to="/recommendation/login" />
    }

    return children;
}

export default RecomEnginePrivateRoute;